import { PaymentOptions } from '@reward-platform/order-schemas/basket'
import { PromotionObject } from './promotionType'

export const getPaymentOptionPromotions = (
  paymentOptions: PaymentOptions,
  paymentOptionId?: string
): PromotionObject[] | undefined => {
  if (!paymentOptionId) {
    return undefined
  }

  if (paymentOptions.onlyCashPaymentOption?.id === paymentOptionId) {
    return paymentOptions.onlyCashPaymentOption.promotions
  }

  return paymentOptions.options.find(({ id }) => id === paymentOptionId)?.promotions
}
